import { render, staticRenderFns } from "./BusinessDetails.vue?vue&type=template&id=0b698b29"
import script from "./BusinessDetails.vue?vue&type=script&lang=js"
export * from "./BusinessDetails.vue?vue&type=script&lang=js"
import style0 from "./BusinessDetails.vue?vue&type=style&index=0&id=0b698b29&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports